// The support desk's URL search, apart from its queries so the router reads it without loading the desk.
/** The queue's tabs (SUP-31), and Closed. */
export const QUEUES = ["new", "mine", "waiting", "escalated", "closed"] as const;
export type Queue = (typeof QUEUES)[number];

export type SupportSearch = { queue?: Queue; q?: string };

/** The desk's search from the URL; anything else is dropped. */
export function parseSupportSearch(s: Record<string, unknown>): SupportSearch {
  return {
    ...(typeof s.queue === "string" && (QUEUES as readonly string[]).includes(s.queue)
      ? { queue: s.queue as Queue }
      : {}),
    ...(typeof s.q === "string" && s.q.trim() ? { q: s.q.trim().slice(0, 64) } : {}),
  };
}
